import { createContext, useContext, useState, useMemo, useCallback } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  const add = useCallback((product) => {
    setItems((prev) => {
      const found = prev.find((i) => i.slug === product.slug);
      if (found) return prev.map((i) => (i.slug === product.slug ? { ...i, qty: i.qty + 1 } : i));
      return [...prev, { ...product, qty: 1 }];
    });
    toast.success(`${product.name} added to bag`);
    setOpen(true);
  }, []);

  const remove = useCallback((slug) => setItems((p) => p.filter((i) => i.slug !== slug)), []);
  const setQty = useCallback((slug, qty) =>
    setItems((p) => p.map((i) => (i.slug === slug ? { ...i, qty: Math.max(1, qty) } : i))), []);
  const clear = useCallback(() => setItems([]), []);

  const count = useMemo(() => items.reduce((a, i) => a + i.qty, 0), [items]);
  const total = useMemo(() => items.reduce((a, i) => a + i.qty * i.price, 0), [items]);

  const value = { items, open, setOpen, add, remove, setQty, clear, count, total };
  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};
